export const campos = [
  {
    headerName: '',
    field: '',
    width: 300,
  },
  {
    headerName: 'ID',
    field: 'id',
    hide: true,
  },
  {
    headerName: 'Correos',
    field: 'email',
    width: 600,
  },
  {
    headerName: 'Estado',
    field: 'activo',
    width: 300,
  },
  {
    headerName: 'Fecha de Creación',
    field: 'fecha_creacion',
    hide: true,
  },
  {
    headerName: 'Usuario Creador',
    field: 'usuario_creador',
    hide: true,
  },
  {
    headerName: 'Fecha de Modificación',
    field: 'fecha_modificacion',
    hide: true,
  },
  {
    headerName: 'Usuario Modificador',
    field: 'usuario_oodificiacion',
    hide: true,
  },
];